/* import __COLOCATED_TEMPLATE__ from './activate-debit-card.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import assert from '@banking/ui/utils/assert';
import productNameTranslationKey from '@banking/ui/utils/checking/product-name-translation-key';
import { Country } from '@square/dashboard-protos/models/squareup/common/countries';
import { getActivationUpsellImage } from '@banking/ui/utils/checking-image-urls';
let ActivateDebitCard = (_class = class ActivateDebitCard extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "userInfo", _descriptor, this);
    _initializerDefineProperty(this, "debitCardActivationUpsell", _descriptor2, this);
    _initializerDefineProperty(this, "intl", _descriptor3, this);
    _initializerDefineProperty(this, "assetMap", _descriptor4, this);
    _initializerDefineProperty(this, "features", _descriptor5, this);
    _initializerDefineProperty(this, "dataApi", _descriptor6, this);
    _initializerDefineProperty(this, "storedBalanceProductPositioning", _descriptor7, this);
    assert(this.args.unitToken);
    if (this.features.isEnabled('bizbank/show_card_activation_upsell')) {
      this.debitCardActivationUpsell.fetch([this.args.unitToken]);
    }
  }
  get showUpsell() {
    return this.debitCardActivationUpsell.doesUnitHaveActivatableCard(this.args.unitToken);
  }
  get cardImageUrl() {
    const country = Country[this.userInfo.countryCode];
    if (!(country === Country.US || country === Country.CA)) {
      throw new Error(`Country "${country}" is not supported within stored balance routes.`);
    }
    const countryAlphaCode = this.userInfo.countryCode;
    return this.assetMap.resolve(getActivationUpsellImage(countryAlphaCode));
  }
  get cardImageAlt() {
    return this.intl.t(productNameTranslationKey(this.storedBalanceProductPositioning.productName, 'banking.checking.onboarding.marketing.heroAlt'));
  }
  get upsellTitle() {
    return this.debitCardActivationUpsell.upsellTitle;
  }
  get buttonTitle() {
    return this.debitCardActivationUpsell.buttonTitle;
  }
  openCardActivationModal() {
    this.debitCardActivationUpsell.openCardActivationModal(this.args.unitToken);
    this.dataApi.track('Click Square Checking Home', {
      action: 'Click',
      applet: 'Banking',
      feature: 'Square Checking Home',
      page: 'Activation Upsell',
      target: 'Activate Now'
    });
  }
  closeCardActivationModal() {
    this.debitCardActivationUpsell.closeCardActivationModal();
  }
  trackUpsellView() {
    this.dataApi.track('View Square Checking Home', {
      action: 'View',
      applet: 'Banking',
      feature: 'Square Checking Home',
      page: 'Activation Upsell'
    });
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "debitCardActivationUpsell", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "assetMap", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "storedBalanceProductPositioning", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "openCardActivationModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openCardActivationModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeCardActivationModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeCardActivationModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trackUpsellView", [action], Object.getOwnPropertyDescriptor(_class.prototype, "trackUpsellView"), _class.prototype)), _class);
export { ActivateDebitCard as default };